import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/fastener-tooling-mapping*`. Composite PK (partNo, toolingSetId)
// — exposed via `?partNo=&toolingSetId=` query params on the `/lookup`
// sub-path. Bare collection path is the paginated list / create.

export interface FastenerToolingMapping {
  partNo: string;
  toolingSetId: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedFastenerToolingMappings {
  data: FastenerToolingMapping[];
  pagination: PaginationMeta;
}

export interface ListFastenerToolingMappingParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface FastenerToolingMappingKey {
  partNo: string;
  toolingSetId: string;
}

export interface CreateFastenerToolingMappingBody {
  partNo: string;
  toolingSetId: string;
}

export interface UpdateFastenerToolingMappingBody {
  partNo: string;
  toolingSetId: string;
}

export async function listFastenerToolingMapping(
  params: ListFastenerToolingMappingParams = {},
): Promise<PaginatedFastenerToolingMappings> {
  const res = await Api.get("/v1/fastener-tooling-mapping", { params });
  return unwrap<PaginatedFastenerToolingMappings>(res.data);
}

export async function getFastenerToolingMapping(
  key: FastenerToolingMappingKey,
): Promise<FastenerToolingMapping> {
  const res = await Api.get("/v1/fastener-tooling-mapping/lookup", { params: key });
  return unwrap<FastenerToolingMapping>(res.data);
}

export async function createFastenerToolingMapping(
  body: CreateFastenerToolingMappingBody,
): Promise<FastenerToolingMapping> {
  const res = await Api.post("/v1/fastener-tooling-mapping", body);
  return unwrap<FastenerToolingMapping>(res.data);
}

export async function updateFastenerToolingMapping(
  oldKey: FastenerToolingMappingKey,
  body: UpdateFastenerToolingMappingBody,
): Promise<FastenerToolingMapping> {
  const res = await Api.put("/v1/fastener-tooling-mapping/lookup", body, { params: oldKey });
  return unwrap<FastenerToolingMapping>(res.data);
}

export async function deleteFastenerToolingMapping(
  key: FastenerToolingMappingKey,
): Promise<void> {
  await Api.delete("/v1/fastener-tooling-mapping/lookup", { params: key });
}
